module.exports = "<rb-empty-header></rb-empty-header>\n<div class=\"public-content pageWithHeaderBody\"></div>\n";